import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import surah from './db/surah.json'
import HomeComponent from './components/HomeComponent'
import SurahComponent from './components/SurahComponent'
import NoMatchComponent from './components/NoMatchComponent'
import PrivateRoute from './components/PrivateRoute'

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={() => <HomeComponent surah={surah} />} />
        <Route exact path="/404" component={NoMatchComponent} />
        <PrivateRoute path="/:surahName" component={SurahComponent} />
      </Switch>
    </Router>
  )
}

export default App
